import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiPlaceOrder } from "@/api";
import {
  PlaceOrderResultCode,
  type PlaceOrderRequest,
  type PlaceOrderResponse,
} from "@/api/types";
import { showError } from "@/lib/toast";
import { useTranslation } from "react-i18next";

/**
 * AI 下单（/game/cex/PlaceOrder）
 *
 * 入参请按 `PlaceOrderRequest` 传入：
 * - strategyId / action / entryPrice / stopLoss / takeProfit / leverage / positionValue ...
 */
export function usePlaceOrder() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  ``;
  return useMutation({
    mutationFn: async (
      data: PlaceOrderRequest
    ): Promise<PlaceOrderResponse> => {
      console.log("usePlaceOrder", data);
      const res = await ApiPlaceOrder(data);
      console.log("usePlaceOrder", res.data);
      return res.data;
    },
    onError: error => {
      console.error("usePlaceOrder error", error);
      showError("下单失败，请稍后重试");
    },
    onSuccess: data => {
      if (data.resultCode === PlaceOrderResultCode.Success) {
        queryClient.invalidateQueries({ queryKey: ["openOrderList"] });
        queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
        return;
      }
      if (data.resultCode === PlaceOrderResultCode.OkxAvailCashRatio) {
        showError(
          t("aiTradingPage.strategyWizard.toastSignalVolatilityTooHigh")
        );
      }
      if (data.resultCode === PlaceOrderResultCode.ChannelClose) {
        showError(t("common.comingSoon"));
      }
      showError(data.resultMsg || "下单失败");
    },
  });
}
